import PropTypes from "prop-types";
import { getMetadata } from "@/features/metadata/metadataSlice";
import { getToken } from "@/features/token/tokenSlice";
import { useSelector } from "react-redux";

import { APP_NAMES, PUBLIC_PATHS, RESOURCE_ROUTE_MAP } from "@/config/constants";
import { useCallback, useEffect, useState } from "react";
import { useRouter } from "next/router";

/** Check if the token is stored in the store.
 * Check if token has expired
 * Check for userType & intent and check if user is allowed to access the token.
 */
const Authorize = ({ children }) => {
  const router = useRouter();
  const token = useSelector(getToken);
  const metadata = useSelector(getMetadata);
  
  const [hasAccess, setHasAccess] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  const isPublicPath = useCallback(() => {
    // return PUBLIC_PATHS.includes(router.pathname);
    // Uncomment below line and comment above line to disable authorization.
    return true;
  }, [router.pathname]);

  useEffect(() => {
    function handleAuthorization() {
      // If public url then allow access.
      if (isPublicPath()) {
        setHasAccess(true);
        return;
      }

      const {
        appName: userType,
        clientType: source,
        resource: intent,
      } = metadata;

      if (!token) {
        // Unauthorized access
        setHasAccess(false);
        setErrorMessage("You do not have access to view this page");
        return;
      }
      switch (userType) {
        case APP_NAMES.CUSTOMER_WEB: {
          // Has full access.
          setHasAccess(true);
          break;
        }
        case APP_NAMES.CRM:
        case APP_NAMES.IPDS:
        case APP_NAMES.WHATSAPP_BOT: {
          // Access by resource only.
          if (
            isPublicPath &&
            RESOURCE_ROUTE_MAP[intent].includes(router.pathname)
          ) {
            setHasAccess(true);
          }
          break;
        }
        default: {
          // Unauthorized
          setHasAccess(false);
          setErrorMessage("You do not have access to view this page");
        }
      }
    }

    handleAuthorization();
  }, [isPublicPath, router.pathname, token, metadata]);
  

  return hasAccess ? (
    <>{children}</>
  ) : (
    <>
      <h3>Access denied</h3>
      <p>{errorMessage}</p>
    </>
  );
};

Authorize.propTypes = {
  children: PropTypes.element
};

export default Authorize;
